import type { IconNode } from '../types';

/**
 * @name pancakes
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgMTEuNmMzLjUtLjggNi0yLjUgNi00LjYgMC0yLjgtNC41LTUtMTAtNVMyIDQuMiAyIDdjMCAyLjUgMy43IDQuNiA4LjQgNSIgLz4KICA8cGF0aCBkPSJNMy4zIDkuNUMyLjUgMTAuMiAyIDExLjEgMiAxMmMwIDIuOCA0LjUgNSAxMCA1aC4zIiAvPgogIDxwYXRoIGQ9Ik0xNS45IDE2LjZjMy42LS44IDYuMS0yLjUgNi4xLTQuNiAwLS45LS41LTEuOC0xLjMtMi41IiAvPgogIDxwYXRoIGQ9Ik0zLjMgMTQuNUMyLjUgMTUuMiAyIDE2LjEgMiAxN2MwIDIuOCA0LjUgNSAxMCA1czEwLTIuMiAxMC01YzAtLjktLjUtMS44LTEuMy0yLjUiIC8+CiAgPHBhdGggZD0iTTE2IDE2YTIgMiAwIDAgMS00IDB2LTJjMC0xLjEtLjktMi0yLTIuMi0xLjgtLjUtMy0xLjYtMy0yLjggMC0xLjcgMi4yLTMgNS0zczUgMS4zIDUgM2MwIC40LS4xLjctLjMgMS4xLS4zLjUtLjcgMS4yLS43IDEuN1oiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/pancakes
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pancakes: IconNode = [
  [
    'path',
    {
      d: 'M16 11.6c3.5-.8 6-2.5 6-4.6 0-2.8-4.5-5-10-5S2 4.2 2 7c0 2.5 3.7 4.6 8.4 5',
      key: '1g36de',
    },
  ],
  ['path', { d: 'M3.3 9.5C2.5 10.2 2 11.1 2 12c0 2.8 4.5 5 10 5h.3', key: '7k0cvw' }],
  ['path', { d: 'M15.9 16.6c3.6-.8 6.1-2.5 6.1-4.6 0-.9-.5-1.8-1.3-2.5', key: 'jtl9b2' }],
  [
    'path',
    {
      d: 'M3.3 14.5C2.5 15.2 2 16.1 2 17c0 2.8 4.5 5 10 5s10-2.2 10-5c0-.9-.5-1.8-1.3-2.5',
      key: 'yb3iei',
    },
  ],
  [
    'path',
    {
      d: 'M16 16a2 2 0 0 1-4 0v-2c0-1.1-.9-2-2-2.2-1.8-.5-3-1.6-3-2.8 0-1.7 2.2-3 5-3s5 1.3 5 3c0 .4-.1.7-.3 1.1-.3.5-.7 1.2-.7 1.7Z',
      key: 'p7t2hh',
    },
  ],
];

export default pancakes;
